import AddressesActionTypes from './addresses-types'

const INITIAL_STATE = {
    loader: null,
    success: null,
    addresses: null,
    error: null,
}

const addressesReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case AddressesActionTypes.START_GET_ADDRESSES_SUBSCRIPTIONS:
            return {
                ...state,
                loader: { ...state.loader, ADDRESS_SUBSCRIPTIONS: true },
            }
        case AddressesActionTypes.SUCCESS_GET_ADDRESSES_SUBSCRIPTIONS:
            return {
                ...state,
                loader: { ...state.loader, ADDRESS_SUBSCRIPTIONS: null },
                addresses: action.payload,
            }
        case AddressesActionTypes.START_BUY_ADDRESS_SUBSCRIPTION:
            return {
                ...state,
                loader: { ...state.loader, BUY_ADDRESS_SUBSCRIPTION: true },
                success: null,
            }
        case AddressesActionTypes.SUCCESS_BUY_ADDRESS_SUBSCRIPTION:
            return {
                ...state,
                loader: { ...state.loader, BUY_ADDRESS_SUBSCRIPTION: null },
                success: { ...state.success, BUY_ADDRESS_SUBSCRIPTION: true },
            }
        case AddressesActionTypes.FINISH_BUY_ADDRESS_SUBSCRIPTION:
            return {
                ...state,
                loader: { ...state.loader, BUY_ADDRESS_SUBSCRIPTION: null },
                success: null,
            }
        case AddressesActionTypes.FAILURE_BUY_ADDRESS_SUBSCRIPTION:
            return {
                ...state,
                error: true,
                success: null,
                loader: { ...state.loader, BUY_ADDRESS_SUBSCRIPTION: null },
            }
        case AddressesActionTypes.START_CHANGE_SHIPPING_ADDRESS:
            return {
                ...state,
                loader: { ...state.loader, CHANGE_SHIPPING_ADDRESS: true },
                success: null,
            }
        case AddressesActionTypes.SUCCESS_CHANGE_SHIPPING_ADDRESS:
            return {
                ...state,
                loader: { ...state.loader, CHANGE_SHIPPING_ADDRESS: null },
                success: { ...state.success, CHANGE_SHIPPING_ADDRESS: true },
            }
        case AddressesActionTypes.FINISH_CHANGE_SHIPPING_ADDRESS:
            return {
                ...state,
                loader: { ...state.loader, CHANGE_SHIPPING_ADDRESS: null },
                success: null,
            }
        case AddressesActionTypes.FAILURE_CHANGE_SHIPPING_ADDRESS:
            return {
                ...state,
                error: true,
                success: null,
                loader: { ...state.loader, CHANGE_SHIPPING_ADDRESS: null },
            }

        case AddressesActionTypes.START_VERIFY_PRIMARY_ADDRESS:
            return {
                ...state,
                loader: { ...state.loader, VERIFY_PRIMARY_ADDRESS: true },
            }
        case AddressesActionTypes.SUCCESS_VERIFY_PRIMARY_ADDRESS:
            return {
                ...state,
                loader: { ...state.loader, VERIFY_PRIMARY_ADDRESS: null },
                success: { ...state.success, VERIFY_PRIMARY_ADDRESS: true },
                error: null,
            }
        case AddressesActionTypes.FINISH_VERIFY_PRIMARY_ADDRESS:
            return {
                ...state,
                loader: { ...state.loader, VERIFY_PRIMARY_ADDRESS: null },
                success: { ...state.success, VERIFY_PRIMARY_ADDRESS: null },
                error: null,
            }
        case AddressesActionTypes.FAILURE_VERIFY_PRIMARY_ADDRESS:
            return {
                ...state,
                loader: { ...state.loader, VERIFY_PRIMARY_ADDRESS: null },
                success: { ...state.success, VERIFY_PRIMARY_ADDRESS: null },
                error: true,
            }

        default:
            return state
    }
}

export default addressesReducer
